import { datadogRum } from "@datadog/browser-rum";

/**
 * Motivos de negação/redirect de acesso nos guards de rota.
 * Padroniza o rastreio para facilitar troubleshooting no Datadog:
 * dado um usuário que "cai na Agenda e Vem", é possível saber qual
 * regra disparou o redirect. Ver SP-1315.
 */
export enum AccessDenialReason {
  /** SP-1315: perfil motorista puro (cif_driver/fob_driver sem carrier). */
  DRIVER_ONLY_PROFILE_BLOCKED = "driver_only_profile_blocked",
  /** Regra pré-existente: perfil motorista (CIF) ou transportadora. */
  DRIVER_OR_CARRIER_PROFILE_REDIRECT = "driver_or_carrier_profile_redirect",
}

interface AccessDenialContext {
  reason: AccessDenialReason;
  /** Rota de destino do redirect. */
  redirectTo: string;
  /** Contexto adicional opcional (ex: rota de origem, flags relevantes). */
  [key: string]: unknown;
}

/**
 * Registra uma negação/redirect de acesso como ação customizada no Datadog RUM
 * (com fallback no console). Usar nos guards para rastrear qual regra bloqueou
 * o acesso do usuário.
 */
export function logAccessDenial(context: AccessDenialContext): void {
  try {
    datadogRum.addAction("access_denied", context);
  } catch {
    // Datadog pode não estar inicializado (ex: ambiente de teste/dev).
    // Não deixar a instrumentação quebrar o fluxo de navegação.
  }

  // eslint-disable-next-line no-console
  console.info(`[access-denied] reason=${context.reason}`, context);
}
